_ = require 'lodash'

_createLightboxPage = (editor, options) ->
  new window.lp.pom.Page {
    page:
      used_as: 'lightbox'
    name: options.name
    settings:
      defaultWidth: options.size.width,
      activeGoals: editor.mainPage.settings.activeGoals,
      contentType: editor.mainPage.settings.contentType,
      multipleBreakpointsVisibility: editor.mainPage.settings.multipleBreakpointsVisibility
      desktopBreakpointDisabled: editor.mainPage.settings.desktopBreakpointDisabled
      mainPage:
        # Information about the main page is stored in lightbox pages so that forms on
        # lightboxes can submit to the right page (see form_element.js)
        uuid       : editor.mainPage.page.uuid
        variant_id : editor.mainPage.variant_id
    elements: [
      _.merge {}, window.lp.module.root.RootElement.elementDefaults,
        id: 'lp-pom-root',
        type: 'lp-pom-root',
        containerId: null,
        geometry:
          contentWidth: options.size.width
    ]
    styles: []
  }, editor.mainPage.context


_addElementsToPage = (lightboxPage, options) ->
  lightboxPage.undoManager.disable()

  root = lightboxPage.getRootElement()
  section = window.lp.getModule('lp-pom-block').addNewElementToPage lightboxPage,
    container: root
  section.set 'geometry.size.height', options.size.height

  lightboxPage.undoManager.enable()


_generateName = (name, editor) ->
  editor.generatePageName(if /^Lightbox\ [0-9]*$/.test(name) then 'Lightbox' else name)


createLightbox = (editor, options) ->
  defaultOptions =
    name: 'Lightbox'
    size:
      width: 840
      height: 480

  options = _.merge defaultOptions, options
  options.name = _generateName options.name, editor

  lightboxPage = _createLightboxPage editor, options
  _addElementsToPage lightboxPage, options
  return lightboxPage


module.exports = {createLightbox}



// WEBPACK FOOTER //
// ./src/lp/editor/lightbox-factory.coffee